import React from "react";
import { useNavigate } from "react-router-dom";

interface IProps {
    datas?: { Ean: string; idnotice: string; idmessage?:string,iddemande?:string }[];
    PathNamePrefixe?: string;
    currentValueEan: string;
    currentValueIdNotice: string;
    currentValueIdMessage?:string;
    currentValueIdDemande?:string;
}

const CpntNavigatorNotice: React.FC<IProps> = ({ datas, PathNamePrefixe, currentValueIdNotice,currentValueIdMessage,currentValueIdDemande }) => {
    const navigate = useNavigate();

    //const indexEan = datas?.findIndex(d => d.Ean === currentValueEan) ?? -1;
    const indexIdNotice = datas?.findIndex(d => d.idnotice.toString().trim() === currentValueIdNotice.toString().trim()
                    && (!currentValueIdMessage ||!d.idmessage || d.idmessage.toString().trim() === currentValueIdMessage.toString().trim())
                    && (!currentValueIdDemande || !d.iddemande || d.iddemande.toString().trim() === currentValueIdDemande.toString().trim())) 
                    ?? -1;


    const previous = () => {
        if (datas && indexIdNotice > 0) {
            const previousData = datas[indexIdNotice - 1];
            const pathPrefixe = PathNamePrefixe ?? `${"./"}${previousData?.Ean ? `../` : ''}${previousData?.idnotice ? `../` : ''}${previousData?.idmessage ? `../` : ''}${previousData?.iddemande ? `../` : ''}`;
            navigate(`${pathPrefixe}${previousData.Ean}${previousData?.idnotice ? `/${previousData.idnotice}` : ''}${previousData?.idmessage ? `/${previousData.idmessage}` : ''}${previousData?.iddemande ? `/${previousData.iddemande}` : ''}`);
        }
    };

    const next = () => {
        if (datas && indexIdNotice < datas.length - 1) {
            const nextData = datas[indexIdNotice + 1];
            const pathPrefixe = PathNamePrefixe ?? `${"./"}${nextData?.Ean ? `../` : ''}${nextData?.idnotice ? `../` : ''}${nextData?.idmessage ? `../` : ''}${nextData?.iddemande ? `../` : ''}` ;
            navigate(`${pathPrefixe}${nextData.Ean}${nextData?.idnotice ? `/${nextData.idnotice}` : ''}${nextData?.idmessage ? `/${nextData.idmessage}` : ''}${nextData?.iddemande ? `/${nextData.iddemande}` : ''}`);
        }
    };

    return (
        <>
            {datas && datas.length > 0 && (
                <div>
                    {indexIdNotice > 0 ? (
                        <i className="bi bi-arrow-left-square-fill App-icon-size-Big me-1 text-secondary Pointer" onClick={previous}></i>
                    ) : (
                        <i className="bi bi-arrow-left-square-fill App-icon-size-Big me-1 text-grey"></i>
                    )}
                    <span className="titreModule pb-2">
                        <i>{indexIdNotice + 1}</i>{`/${datas.length}`}
                    </span>
                    {indexIdNotice < datas.length - 1 ? (
                        <i className="bi bi-arrow-right-square-fill App-icon-size-Big ms-1 text-secondary Pointer" onClick={next}></i>
                    ) : (
                        <i className="bi bi-arrow-right-square-fill App-icon-size-Big ms-1 text-grey"></i>
                    )}
                </div>
            )}
        </>
    );
};

export default CpntNavigatorNotice;
